export default __webpack_public_path__ + "src/images/packages/summerfields-rose-retreat/95f8ec8ecea5695411727640f576c336-5.jpg";